export function generateEquipmentName(equipment: any) {
  return [equipment.year, equipment.make, equipment.model]
    .filter(Boolean)
    .map((part) => part?.toUpperCase())
    .join(' ');
}
